import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { ForgotPasswordModel } from './model/ForgotPasswordModel';
import { ForgotPasswordController } from './controller/ForgotPasswordController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem, Navigation } from 'utils/Navigation';
import { AuthCard } from '../AuthCard';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class ForgotPasswordScene extends AScene<Props, ForgotPasswordModel, ForgotPasswordController> {

    private email: string = "";

    public constructor(props: Props) {
        super(props);

        this.handleSubmitClicked = this.handleSubmitClicked.bind(this);
    }

    protected createControlller(): ForgotPasswordController {
        return new ForgotPasswordController();
    }

    private handleSubmitClicked() {
        this.controller.onSubmitClicked(this.email);
    }

    public render(): React.ReactNode {
        if (this.model.submitted) {
            return (
                <AuthCard title="Forgot password">
                    <div style={{ textAlign: 'center', fontSize: '15px', color: '#888', marginBottom: '24px' }}>
                        If an account exists for that email address, we've sent a password reset link. Please check your inbox (and your spam folder).
                    </div>
                    <div style={{ textAlign: 'center', fontSize: '14px' }}>
                        <a href="/login.rsc" style={{ color: '#009155' }} onClick={(e) => { e.preventDefault(); Navigation.pushState(null, "/login.rsc"); }}>Back to login</a>
                    </div>
                </AuthCard>
            );
        }

        this.email = this.model.email;
        return (
            <AuthCard title="Forgot password" error={this.model.error}>
                <div style={{ textAlign: 'center', fontSize: '15px', color: '#888', marginBottom: '24px' }}>
                    Enter your email address and we'll send you a link to reset your password.
                </div>
                <TextField label="Email" value={this.model.email} onChange={(v) => { this.email = v; }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '8px' }}>
                    <Button color="primary" variant="contained" onClick={this.handleSubmitClicked}>Send reset link</Button>
                </div>
                <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '14px' }}>
                    <a href="/login.rsc" style={{ color: '#009155' }} onClick={(e) => { e.preventDefault(); Navigation.pushState(null, "/login.rsc"); }}>Back to login</a>
                </div>
            </AuthCard>
        );
    }

}

export class Props {

}

export class ForgotPasswordSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <ForgotPasswordScene />
        );
    }

}
